import React from "react";
import IntroductionSection from "./sections/IntroductionSection";
import CommitmentSection from "./sections/CommitmentSection";
import TeamSection from "./sections/TeamSection";
import StoreLocationsSection from "./sections/StoreLocationsSection";
import ValuesSection from "./sections/ValuesSection";

const AboutUsPage = () => {
  return (
    <div className="w-full bg-gray-100">
      {/* Section: Introduction */}
      <IntroductionSection />

      {/* Section: Values */}
      <ValuesSection />

      {/* Section: Commitments */}
      <CommitmentSection />

      {/* Section: Team */}
      <TeamSection />

      {/* Section: Store Locations */}
      <StoreLocationsSection />
    </div>
  );
};

export default AboutUsPage;
